import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';

import { ucFirst } from 'Helpers/String';
import { calculateCartItemsPrice } from 'Helpers/Cart';
import { getRouteByName } from 'Helpers/Routes';

import Modal from 'Components/layout/Modal';
import Spinner from 'Components/layout/Spinner';
import Button from 'Components/layout/Button';

export default class CartCreditsModal extends React.Component {
    static propTypes = {
        visible: PropTypes.bool.isRequired,
        onHideDemoModal: PropTypes.func.isRequired,
        onSelect: PropTypes.func.isRequired,
        selectedPackageId: PropTypes.string,
        creditPackage: PropTypes.shape({
            id: PropTypes.string.isRequired,
            price: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            worthPhotos: PropTypes.number.isRequired,
            discountPercentage: PropTypes.number.isRequired
        }),
        cart: PropTypes.shape({
            items: PropTypes.arrayOf(
                PropTypes.shape({
                    price: PropTypes.number
                })
            ),
            totalPrice: PropTypes.number.isRequired,
        }).isRequired,
    };
    static defaultProps = {};

    render() {
        const { visible, onHideDemoModal, creditPackage, selectedPackageId } = this.props;
        const { items, totalPrice } = this.props.cart;

        if (!creditPackage || !items.length || !totalPrice) {
            return (
                <Modal
                    className="component-cart-credits-modal"
                    visible={visible}
                    onHide={onHideDemoModal}
                    hideOnBackground={false}
                >
                    <Spinner />
                </Modal>
            );
        }

        return (
            <Modal
                className="component-cart-credits-modal"
                visible={visible}
                onHide={onHideDemoModal}
                hideOnBackground={false}
            >
                <h2 className="credits-modal-headline">Save $ with packages</h2>
                <div className="package-list">
                    <div
                        className={`package-box package-user ${selectedPackageId ? '' : 'active'}`}
                        onClick={() => this.props.onSelect('')}
                    >
                        <div className="radio-button"></div>
                        <div className="package-header">
                            <p className="package-name">{items.length} {items.length < 2 ? 'photo' : 'photos'}</p>
                            <h4 className="package-woth-photos">Single {items.length < 2 ? 'photo' : 'photos'}</h4>
                        </div>
                        <div className="package-footer">
                            <span className="package-price">
                                <sup>$</sup>{calculateCartItemsPrice(items).toFixed(2)}
                            </span>
                            <p className="package-savings">No discount</p>
                        </div>
                    </div>
                    <div
                        className={`package-box ${selectedPackageId === creditPackage.id ? 'active' : ''}`}
                        onClick={() => this.props.onSelect(creditPackage)}
                    >
                        <div className="radio-button"></div>
                        <div className="package-header">
                            <p className="package-name">{ucFirst(creditPackage.name)} Package</p>
                            <h4 className="package-woth-photos">{creditPackage.worthPhotos} photos</h4>
                        </div>
                        <div className="package-footer">
                            <span className="package-price">
                                <sup>$</sup>{creditPackage.price.toFixed(2)}
                            </span>
                            <p className="package-savings active">You save {creditPackage.discountPercentage}%</p>
                        </div>
                    </div>
                </div>
                <div className="credits-modal-footer">
                    <p className="cta-copy">Photos will be redeemed from the package</p>
                    <Button
                        size="l"
                        layout="wide"
                        element="anchor"
                        to={getRouteByName('payment').path}
                        id="btn-payment"
                    >
                        Continue
                    </Button>
                </div>
            </Modal >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/cart/CreditsModal/index.js